import { logger } from '@lusha/client-logger';
import { autorun } from 'mobx';
import { flow, getRoot } from 'mobx-state-tree';
import { getBusinessOpportunitiesAnalytics, getBusinessOpportunitiesCount, getNewBusinessOpportunities, } from '../../../API/businessOpportunities';
const Actions = self => ({
    afterCreate() {
        if (envConfig.BUSINESS_OPPORTUNITIES) {
            autorun(() => {
                const { community: { isCommunityMember, isLoaded, isOutlookSettingsLoaded }, } = getRoot(self);
                if (isLoaded && isCommunityMember && isOutlookSettingsLoaded) {
                    self.fetchBusinessOpportunitiesData();
                }
            });
        }
    },
    fetchBusinessOpportunitiesData: flow(function* fetchBusinessOpportunitiesData() {
        try {
            self.isLoaded = false;
            const promises = [];
            promises.push(getBusinessOpportunitiesAnalytics());
            promises.push(getNewBusinessOpportunities());
            promises.push(getBusinessOpportunitiesCount());
            const [analytics, newSignals, signalsCount] = yield Promise.all(promises);
            self.firstPromoVisit = analytics === null || analytics === void 0 ? void 0 : analytics.firstPromoVisit;
            self.newSignals = (newSignals === null || newSignals === void 0 ? void 0 : newSignals.total) || 0;
            self.signalsCount = (signalsCount === null || signalsCount === void 0 ? void 0 : signalsCount.total) || 0;
            self.isLoaded = true;
        }
        catch (e) {
            logger.warn('Error fetching business opportunities data', e);
            self.isLoaded = true;
        }
    }),
    setDisplayOpportunities(setter) {
        self.displayOpportunities = setter;
    },
});
export default Actions;
